import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { RedesignCommandPalette } from 'root/src/client/v2/layout/features/RedesignCommandPalette/RedesignCommandPalette';
const RedesignCommandPaletteContext = createContext(null);
export const useRedesignCommandPalette = () => {
    const ctx = useContext(RedesignCommandPaletteContext);
    if (!ctx) {
        throw new Error('useRedesignCommandPalette must be used within a RedesignCommandPaletteProvider');
    }
    return ctx;
};
// Owns the command palette open state and renders the palette once for the whole redesign subtree, so
// the navbar search button (and the Cmd/Ctrl+K shortcut) can drive it without prop drilling. The
// palette + shortcut are mounted only when `enabled` (redesign routes); on legacy routes this is a
// transparent passthrough.
export const RedesignCommandPaletteProvider = ({ enabled, children }) => {
    const [open, setOpen] = useState(false);
    const openPalette = useCallback(() => setOpen(true), []);
    const closePalette = useCallback(() => setOpen(false), []);
    const toggle = useCallback(() => setOpen(prev => !prev), []);
    const value = useMemo(() => ({ open, setOpen, openPalette, closePalette, toggle }), [open, openPalette, closePalette, toggle]);
    return (<RedesignCommandPaletteContext.Provider value={value}>
			{children}
			{enabled && <RedesignCommandPalette />}
		</RedesignCommandPaletteContext.Provider>);
};
